import { useContext } from 'react';
import { UserContext } from '../../_contexts/UserContext';

export function useUser() {
    return useContext(UserContext);
}
